/* eslint-disable @typescript-eslint/no-explicit-any */
import { HStack } from '@chakra-ui/react';
import { convertDateToUnix } from '@diamond/shared/schema/sap';
import {
  BackofficeGetPromoCounterAdminQuery,
  BackofficePromoCustomerType,
  BackofficePromoMechanism,
  BackofficePromoStatus,
  BackofficePromoType,
  PromoFilterParams,
} from '@diamond/shared/types';
import { DateFilter, MultiSelect, Searchbox, Select } from '@diamond/shared/ui';
import {
  useDateFilter,
  useSearchbox,
  useSelectParams,
} from '@diamond/sol-admin/hooks';
import { useEffect } from 'react';
import { FormProvider, useForm } from 'react-hook-form';

import { PromoList } from '../components';
import { PromoSectionLayout } from '../components/layouts/promo-section-layout';
import {
  mechanismOptions,
  promoListSelectParamsConfig,
  promoTypeOptions,
  statusPromoOptions,
} from '../constant';
import { multiSelectStyles } from '../styles/select-styles';

export function PromoGabunganPage() {
  const {
    register,
    params: searchParams,
    handleSearch,
  } = useSearchbox({
    isDebounce: false,
  });
  const selectParams = useSelectParams<PromoFilterParams>(
    promoListSelectParamsConfig
  );

  const { dateParams, handleDateFilter, updateDateParams, apiDates } =
    useDateFilter({
      fromField: 'promo_date-from',
      toField: 'promo_date-to',
      paramFromName: 'start_date',
      paramToName: 'end_date',
      defaultPeriod: '', // Empty by default
    });

  const methods = useForm({
    defaultValues: {
      'promo_date-from': dateParams['promo_date-from'],
      'promo_date-to': dateParams['promo_date-to'],
    },
  });

  const { reset } = methods;
  const initialFromDate = dateParams['promo_date-from'];
  const initialToDate = dateParams['promo_date-to'];
  useEffect(() => {
    if (initialFromDate && initialToDate) {
      reset(
        {
          'promo_date-from': initialFromDate,
          'promo_date-to': initialToDate,
        },
        {
          keepDirty: true,
          keepErrors: true,
        }
      );
    }
  }, [initialFromDate, initialToDate, reset]);

  const section = 'gabungan';

  const apiCustomerType: BackofficePromoCustomerType | undefined = undefined;

  const startDateTimestamp = apiDates.period_from
    ? convertDateToUnix(new Date(apiDates.period_from), true)
    : undefined;
  const endDateTimestamp = apiDates.period_to
    ? convertDateToUnix(new Date(apiDates.period_to), true)
    : undefined;

  const activeFilters: BackofficeGetPromoCounterAdminQuery = {
    search_query: searchParams.query || undefined,
    start_date: startDateTimestamp,
    end_date: endDateTimestamp,
    mechanism:
      (selectParams.apiParams.mechanism as BackofficePromoMechanism) ||
      undefined,
    promo_type_by_shipto:
      (selectParams.apiParams.promoType as BackofficePromoType) || undefined,
    status:
      (selectParams.apiParams.statusPromo as BackofficePromoStatus) ||
      undefined,
  };
  return (
    <PromoSectionLayout section={section} activeFilters={activeFilters}>
      <FormProvider {...methods}>
        <HStack w="100%">
          <DateFilter
            fromField="promo_date-from"
            toField="promo_date-to"
            shortYearFormat
            buttonVariant="outline"
            onFilterChange={handleDateFilter}
            onCustomDateChange={updateDateParams}
          />

          <MultiSelect
            id="mechanism"
            placeholder="Mekanisme"
            chakraStyles={multiSelectStyles}
            options={mechanismOptions}
            value={selectParams.mechanism}
            onChange={(newValue) => selectParams.updateMechanism(newValue)}
          />

          <Select
            id="promoType"
            placeholder="Umum"
            options={promoTypeOptions}
            value={
              promoTypeOptions.find(
                (opt) => opt.value === selectParams.promoType
              ) || null
            }
            onChange={(newValue) => selectParams.updatePromoType(newValue)}
          />

          <Select
            id="statusPromo"
            placeholder="Tidak Aktif"
            options={statusPromoOptions}
            value={
              statusPromoOptions.find(
                (opt) => opt.value === selectParams.statusPromo
              ) || null
            }
            onChange={(newValue) => selectParams.updateStatusPromo(newValue)}
          />
          <Searchbox
            register={register}
            w="100%"
            maxW="100%"
            placeholder="Cari Kode Promo, Brand, dan Kode Grouping..."
            onKeyPress={(e) => {
              if (e.key === 'Enter') {
                handleSearch();
              }
            }}
          />
        </HStack>
      </FormProvider>

      <PromoList
        searchQuery={searchParams.query}
        customer_type={apiCustomerType as BackofficePromoCustomerType}
        start_date={startDateTimestamp}
        end_date={endDateTimestamp}
        mechanism={selectParams.apiParams.mechanism as BackofficePromoMechanism}
        promo_type={selectParams.apiParams.promoType as BackofficePromoType}
        status_promo={
          selectParams.apiParams.statusPromo as BackofficePromoStatus
        }
      />
    </PromoSectionLayout>
  );
}
